export default __webpack_public_path__ + "src/assets/outbrain_logo.png";